import React from 'react';
import './Button.css';

function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function Button({
  asChild = false,
  variant = 'default',
  size = 'default',
  loading = false,
  className = '',
  disabled = false,
  children,
  ...props
}) {
  const Component = asChild ? 'span' : 'button';
  return (
    <Component
      className={joinClasses('h-btn', `h-btn--${variant}`, `h-btn--${size}`, loading && 'is-loading', className)}
      disabled={disabled || loading}
      {...props}
    >
      {children}
    </Component>
  );
}

